import React from 'react';
import Dialog from '@mui/material/Dialog';
import { ModalLayoutPaper } from '../modalLayout';
import { TRANSITION_DURATION, Z_INDEX } from './const';
import { ModalViewBaseProps } from './model';

export const FullscreenView: React.FC<ModalViewBaseProps> = ({ children, onClose, onClosed, isOpen, modalProps }) => {
  return (
    <Dialog
      {...modalProps}
      PaperComponent={ModalLayoutPaper}
      PaperProps={{
        sx: [
          {
            m: 0,
            maxHeight: '100dvh',
            maxWidth: '100% !important',
            width: '100dvw',
            height: '100dvh',
          },
        ],
      }}
      TransitionProps={{ onExited: onClosed }}
      disableEnforceFocus
      onClose={onClose}
      open={isOpen}
      sx={{ zIndex: Z_INDEX }}
      transitionDuration={TRANSITION_DURATION}
    >
      {children}
    </Dialog>
  );
};

export default FullscreenView;
